import { render } from "./ChartSettingsDialog.vue?vue&type=template&id=31b03260&scoped=true&ts=true"
import script from "./ChartSettingsDialog.vue?vue&type=script&lang=ts"
export * from "./ChartSettingsDialog.vue?vue&type=script&lang=ts"

import "./ChartSettingsDialog.vue?vue&type=style&index=0&id=31b03260&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b03260"]])

export default __exports__